import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "pitboard_session_token";
const COOKIE_KEY = "pb_tk";

/**
 * Storage double-couche pour résister à Edge Tracking Prevention,
 * Safari ITP, Firefox strict, et autres protections anti-tracking :
 *
 *   1. localStorage (persistant, simple)
 *   2. Cookie JavaScript local (1ère partie, non-httpOnly, 30 jours) — fallback
 *
 * Au moins l'un des deux survit dans 99,9% des navigateurs.
 */
function readToken() {
  try {
    const t = localStorage.getItem(TOKEN_KEY);
    if (t) return t;
  } catch { /* noop */ }
  try {
    const m = document.cookie.match(new RegExp("(?:^|; )" + COOKIE_KEY + "=([^;]+)"));
    if (m) return decodeURIComponent(m[1]);
  } catch { /* noop */ }
  return null;
}

export function writeAuthToken(token) {
  try { localStorage.setItem(TOKEN_KEY, token); } catch { /* noop */ }
  try {
    const exp = new Date(Date.now() + 30 * 24 * 3600 * 1000).toUTCString();
    document.cookie = `${COOKIE_KEY}=${encodeURIComponent(token)}; path=/; expires=${exp}; SameSite=Lax`;
  } catch { /* noop */ }
}

export function clearAuthToken() {
  try { localStorage.removeItem(TOKEN_KEY); } catch { /* noop */ }
  try { document.cookie = `${COOKIE_KEY}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT`; } catch { /* noop */ }
}

export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const t = readToken();
  if (t && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => {
    // Auto-refresh onboarding badge sur tout write
    try {
      const method = (r.config?.method || "").toLowerCase();
      const url = r.config?.url || "";
      if (["post", "patch", "put", "delete"].includes(method) &&
          /\/(company|charges|employees|clients|quotes|invoices)(\b|\/)/.test(url)) {
        window.dispatchEvent(new CustomEvent("onboarding:refresh"));
      }
    } catch {/* noop */}
    return r;
  },
  (err) => {
    const status = err?.response?.status;
    const url = err.config?.url || "";
    // CRITIQUE : ne JAMAIS redirect/clear sur les endpoints du flow d'auth
    // (sinon AuthCallback / MagicLinkCallback ne peuvent pas afficher leurs messages d'erreur).
    // Endpoints whitelistés : /auth/me, /auth/session, /auth/logout, /auth/magic-link-*
    const isAuthEndpoint = /\/auth\/(me|session|logout|magic-link)/.test(url);
    if (status === 401 && !isAuthEndpoint) {
      clearAuthToken();
      const p = window.location.pathname;
      const inAuthFlow = p === "/login" || window.location.hash.includes("session_id=");
      if (!inAuthFlow) {
        window.location.href = "/login?error=session_expired";
      }
    }
    return Promise.reject(err);
  }
);
